import Noty from 'noty'

export default function notyMiddleware(router) {
  router.beforeEach((to, from, next) => {
    Noty.closeAll()
    return next()
  });
}
